export enum Role {
  ADMIN = '/admins',
  CUSTOMER = '/customers',
  SAMPLE_CODE_GENERATOR = '/sample-code-generators',
  USER_MANAGER = '/user-managers',
}

// base on ISO 3166-1
export enum CountryEnum {
  'Afghanistan' = 'AF',
  'Albania' = 'AL',
  'Algeria' = 'DZ',
  'American Samoa' = 'AS',
  'Andorra' = 'AD',
  'Angola' = 'AO',
  'Anguilla' = 'AI',
  'Antarctica' = 'AQ',
  'Antigua and Barbuda' = 'AG',
  'Argentina' = 'AR',
  'Armenia' = 'AM',
  'Aruba' = 'AW',
  'Australia' = 'AU',
  'Austria' = 'AT',
  'Azerbaijan' = 'AZ',
  'Bahamas' = 'BS',
  'Bahrain' = 'BH',
  'Bangladesh' = 'BD',
  'Barbados' = 'BB',
  'Belarus' = 'BY',
  'Belgium' = 'BE',
  'Belize' = 'BZ',
  'Benin' = 'BJ',
  'Bermuda' = 'BM',
  'Bhutan' = 'BT',
  'Bolivia, Plurinational State of' = 'BO',
  'Bonaire, Sint Eustatius and Saba' = 'BQ',
  'Bosnia and Herzegovina' = 'BA',
  'Botswana' = 'BW',
  'Bouvet Island' = 'BV',
  'Brazil' = 'BR',
  'British Indian Ocean Territory' = 'IO',
  'Brunei Darussalam' = 'BN',
  'Bulgaria' = 'BG',
  'Burkina Faso' = 'BF',
  'Burundi' = 'BI',
  'Cambodia' = 'KH',
  'Cameroon' = 'CM',
  'Canada' = 'CA',
  'Cape Verde' = 'CV',
  'Cayman Islands' = 'KY',
  'Central African Republic' = 'CF',
  'Chad' = 'TD',
  'Chile' = 'CL',
  'China' = 'CN',
  'Christmas Island' = 'CX',
  'Cocos (Keeling) Islands' = 'CC',
  'Colombia' = 'CO',
  'Comoros' = 'KM',
  'Congo' = 'CG',
  'Congo, the Democratic Republic of the' = 'CD',
  'Cook Islands' = 'CK',
  'Costa Rica' = 'CR',
  'Croatia' = 'HR',
  'Cuba' = 'CU',
  'Curaçao' = 'CW',
  'Cyprus' = 'CY',
  'Czech Republic' = 'CZ',
  "Côte d'Ivoire" = 'CI',
  'Denmark' = 'DK',
  'Djibouti' = 'DJ',
  'Dominica' = 'DM',
  'Dominican Republic' = 'DO',
  'Ecuador' = 'EC',
  'Egypt' = 'EG',
  'El Salvador' = 'SV',
  'Equatorial Guinea' = 'GQ',
  'Eritrea' = 'ER',
  'Estonia' = 'EE',
  'Eswatini' = 'SZ',
  'Ethiopia' = 'ET',
  'Falkland Islands (Malvinas)' = 'FK',
  'Faroe Islands' = 'FO',
  'Fiji' = 'FJ',
  'Finland' = 'FI',
  'France' = 'FR',
  'French Guiana' = 'GF',
  'French Polynesia' = 'PF',
  'French Southern Territories' = 'TF',
  'Gabon' = 'GA',
  'Gambia' = 'GM',
  'Georgia' = 'GE',
  'Germany' = 'DE',
  'Ghana' = 'GH',
  'Gibraltar' = 'GI',
  'Greece' = 'GR',
  'Greenland' = 'GL',
  'Grenada' = 'GD',
  'Guadeloupe' = 'GP',
  'Guam' = 'GU',
  'Guatemala' = 'GT',
  'Guernsey' = 'GG',
  'Guinea' = 'GN',
  'Guinea-Bissau' = 'GW',
  'Guyana' = 'GY',
  'Haiti' = 'HT',
  'Heard Island and McDonald Islands' = 'HM',
  'Holy See (Vatican City State)' = 'VA',
  'Honduras' = 'HN',
  'Hong Kong' = 'HK',
  'Hungary' = 'HU',
  'Iceland' = 'IS',
  'India' = 'IN',
  'Indonesia' = 'ID',
  'Iran, Islamic Republic of' = 'IR',
  'Iraq' = 'IQ',
  'Ireland' = 'IE',
  'Isle of Man' = 'IM',
  'Israel' = 'IL',
  'Italy' = 'IT',
  'Jamaica' = 'JM',
  'Japan' = 'JP',
  'Jersey' = 'JE',
  'Jordan' = 'JO',
  'Kazakhstan' = 'KZ',
  'Kenya' = 'KE',
  'Kiribati' = 'KI',
  "Korea, Democratic People's Republic of" = 'KP',
  'Korea, Republic of' = 'KR',
  'Kuwait' = 'KW',
  'Kyrgyzstan' = 'KG',
  "Lao People's Democratic Republic" = 'LA',
  'Latvia' = 'LV',
  'Lebanon' = 'LB',
  'Lesotho' = 'LS',
  'Liberia' = 'LR',
  'Libya' = 'LY',
  'Liechtenstein' = 'LI',
  'Lithuania' = 'LT',
  'Luxembourg' = 'LU',
  'Macao' = 'MO',
  'Macedonia, the Former Yugoslav Republic of' = 'MK',
  'Madagascar' = 'MG',
  'Malawi' = 'MW',
  'Malaysia' = 'MY',
  'Maldives' = 'MV',
  'Mali' = 'ML',
  'Malta' = 'MT',
  'Marshall Islands' = 'MH',
  'Martinique' = 'MQ',
  'Mauritania' = 'MR',
  'Mauritius' = 'MU',
  'Mayotte' = 'YT',
  'Mexico' = 'MX',
  'Micronesia, Federated States of' = 'FM',
  'Moldova, Republic of' = 'MD',
  'Monaco' = 'MC',
  'Mongolia' = 'MN',
  'Montenegro' = 'ME',
  'Montserrat' = 'MS',
  'Morocco' = 'MA',
  'Mozambique' = 'MZ',
  'Myanmar' = 'MM',
  'Namibia' = 'NA',
  'Nauru' = 'NR',
  'Nepal' = 'NP',
  'Netherlands' = 'NL',
  'New Caledonia' = 'NC',
  'New Zealand' = 'NZ',
  'Nicaragua' = 'NI',
  'Niger' = 'NE',
  'Nigeria' = 'NG',
  'Niue' = 'NU',
  'Norfolk Island' = 'NF',
  'Northern Mariana Islands' = 'MP',
  'Norway' = 'NO',
  'Oman' = 'OM',
  'Pakistan' = 'PK',
  'Palau' = 'PW',
  'Palestine, State of' = 'PS',
  'Panama' = 'PA',
  'Papua New Guinea' = 'PG',
  'Paraguay' = 'PY',
  'Peru' = 'PE',
  'Philippines' = 'PH',
  'Pitcairn' = 'PN',
  'Poland' = 'PL',
  'Portugal' = 'PT',
  'Puerto Rico' = 'PR',
  'Qatar' = 'QA',
  'Romania' = 'RO',
  'Russian Federation' = 'RU',
  'Rwanda' = 'RW',
  'Réunion' = 'RE',
  'Saint Barthélemy' = 'BL',
  'Saint Helena, Ascension and Tristan da Cunha' = 'SH',
  'Saint Kitts and Nevis' = 'KN',
  'Saint Lucia' = 'LC',
  'Saint Martin (French part)' = 'MF',
  'Saint Pierre and Miquelon' = 'PM',
  'Saint Vincent and the Grenadines' = 'VC',
  'Samoa' = 'WS',
  'San Marino' = 'SM',
  'Sao Tome and Principe' = 'ST',
  'Saudi Arabia' = 'SA',
  'Senegal' = 'SN',
  'Serbia' = 'RS',
  'Seychelles' = 'SC',
  'Sierra Leone' = 'SL',
  'Singapore' = 'SG',
  'Sint Maarten (Dutch part)' = 'SX',
  'Slovakia' = 'SK',
  'Slovenia' = 'SI',
  'Solomon Islands' = 'SB',
  'Somalia' = 'SO',
  'South Africa' = 'ZA',
  'South Georgia and the South Sandwich Islands' = 'GS',
  'South Sudan' = 'SS',
  'Spain' = 'ES',
  'Sri Lanka' = 'LK',
  'Suriname' = 'SR',
  'Sudan' = 'SD',
  'Svalbard and Jan Mayen' = 'SJ',
  'Sweden' = 'SE',
  'Switzerland' = 'CH',
  'Syrian Arab Republic' = 'SY',
  'Taiwan, Province of China' = 'TW',
  'Tajikistan' = 'TJ',
  'Tanzania, United Republic of' = 'TZ',
  'Thailand' = 'TH',
  'Timor-Leste' = 'TL',
  'Togo' = 'TG',
  'Tokelau' = 'TK',
  'Tonga' = 'TO',
  'Trinidad and Tobago' = 'TT',
  'Tunisia' = 'TN',
  'Turkey' = 'TR',
  'Turkmenistan' = 'TM',
  'Turks and Caicos Islands' = 'TC',
  'Tuvalu' = 'TV',
  'Uganda' = 'UG',
  'Ukraine' = 'UA',
  'United Arab Emirates' = 'AE',
  'United Kingdom' = 'GB',
  'United States' = 'US',
  'United States Minor Outlying Islands' = 'UM',
  'Uruguay' = 'UY',
  'Uzbekistan' = 'UZ',
  'Vanuatu' = 'VU',
  'Venezuela, Bolivarian Republic of' = 'VE',
  'Viet Nam' = 'VN',
  'Virgin Islands, British' = 'VG',
  'Virgin Islands, U.S.' = 'VI',
  'Wallis and Futuna' = 'WF',
  'Western Sahara' = 'EH',
  'Yemen' = 'YE',
  'Zambia' = 'ZM',
  'Zimbabwe' = 'ZW',
  'Åland Islands' = 'AX',
}

export enum CurrencyEnum {
  'United Arab Emirates dirham' = 'AED',
  'Afghan afghani' = 'AFN',
  'Albanian lek' = 'ALL',
  'Armenian dram' = 'AMD',
  'Netherlands Antillean guilder' = 'ANG',
  'Angolan kwanza' = 'AOA',
  'Argentine peso' = 'ARS',
  'Australian dollar' = 'AUD',
  'Aruban florin' = 'AWG',
  'Azerbaijani manat' = 'AZN',
  'Bosnia and Herzegovina convertible mark' = 'BAM',
  'Barbados dollar' = 'BBD',
  'Bangladeshi taka' = 'BDT',
  'Bulgarian lev' = 'BGN',
  'Bahraini dinar' = 'BHD',
  'Burundian franc' = 'BIF',
  'Bermudian dollar (customarily known as Bermuda dollar)' = 'BMD',
  'Brunei dollar' = 'BND',
  'Boliviano' = 'BOB',
  'Bolivian Mvdol (funds code)' = 'BOV',
  'Brazilian real' = 'BRL',
  'Bahamian dollar' = 'BSD',
  'Bhutanese ngultrum' = 'BTN',
  'Botswana pula' = 'BWP',
  'Belarusian ruble' = 'BYR',
  'Belize dollar' = 'BZD',
  'Canadian dollar' = 'CAD',
  'Congolese franc' = 'CDF',
  'WIR Euro (complementary currency)' = 'CHE',
  'Swiss franc' = 'CHF',
  'WIR Franc (complementary currency)' = 'CHW',
  'Unidad de Fomento (funds code)' = 'CLF',
  'Chilean peso' = 'CLP',
  'Chinese yuan' = 'CNY',
  'Colombian peso' = 'COP',
  'Unidad de Valor Real' = 'COU',
  'Costa Rican colon' = 'CRC',
  'Cuban convertible peso' = 'CUC',
  'Cuban peso' = 'CUP',
  'Cape Verde escudo' = 'CVE',
  'Czech koruna' = 'CZK',
  'Djiboutian franc' = 'DJF',
  'Danish krone' = 'DKK',
  'Dominican peso' = 'DOP',
  'Algerian dinar' = 'DZD',
  'Egyptian pound' = 'EGP',
  'Eritrean nakfa' = 'ERN',
  'Ethiopian birr' = 'ETB',
  'Euro' = 'EUR',
  'Fiji dollar' = 'FJD',
  'Falkland Islands pound' = 'FKP',
  'Pound sterling' = 'GBP',
  'Georgian lari' = 'GEL',
  'Ghanaian cedi' = 'GHS',
  'Gibraltar pound' = 'GIP',
  'Gambian dalasi' = 'GMD',
  'Guinean franc' = 'GNF',
  'Guatemalan quetzal' = 'GTQ',
  'Guyanese dollar' = 'GYD',
  'Hong Kong dollar' = 'HKD',
  'Honduran lempira' = 'HNL',
  'Croatian kuna' = 'HRK',
  'Haitian gourde' = 'HTG',
  'Hungarian forint' = 'HUF',
  'Indonesian rupiah' = 'IDR',
  'Israeli new shekel' = 'ILS',
  'Indian rupee' = 'INR',
  'Iraqi dinar' = 'IQD',
  'Iranian rial' = 'IRR',
  'Icelandic króna' = 'ISK',
  'Jamaican dollar' = 'JMD',
  'Jordanian dinar' = 'JOD',
  'Japanese yen' = 'JPY',
  'Kenyan shilling' = 'KES',
  'Kyrgyzstani som' = 'KGS',
  'Cambodian riel' = 'KHR',
  'Comoro franc' = 'KMF',
  'North Korean won' = 'KPW',
  'South Korean won' = 'KRW',
  'Kuwaiti dinar' = 'KWD',
  'Cayman Islands dollar' = 'KYD',
  'Kazakhstani tenge' = 'KZT',
  'Lao kip' = 'LAK',
  'Lebanese pound' = 'LBP',
  'Sri Lankan rupee' = 'LKR',
  'Liberian dollar' = 'LRD',
  'Lesotho loti' = 'LSL',
  'Lithuanian litas' = 'LTL',
  'Latvian lats' = 'LVL',
  'Libyan dinar' = 'LYD',
  'Moroccan dirham' = 'MAD',
  'Moldovan leu' = 'MDL',
  'Malagasy ariary' = 'MGA',
  'Macedonian denar' = 'MKD',
  'Myanma kyat' = 'MMK',
  'Mongolian tugrik' = 'MNT',
  'Macanese pataca' = 'MOP',
  'Mauritanian ouguiya' = 'MRO',
  'Mauritian rupee' = 'MUR',
  'Maldivian rufiyaa' = 'MVR',
  'Malawian kwacha' = 'MWK',
  'Mexican peso' = 'MXN',
  'Mexican Unidad de Inversion (UDI) (funds code)' = 'MXV',
  'Malaysian ringgit' = 'MYR',
  'Mozambican metical' = 'MZN',
  'Namibian dollar' = 'NAD',
  'Nigerian naira' = 'NGN',
  'Nicaraguan córdoba' = 'NIO',
  'Norwegian krone' = 'NOK',
  'Nepalese rupee' = 'NPR',
  'New Zealand dollar' = 'NZD',
  'Omani rial' = 'OMR',
  'Panamanian balboa' = 'PAB',
  'Peruvian nuevo sol' = 'PEN',
  'Papua New Guinean kina' = 'PGK',
  'Philippine peso' = 'PHP',
  'Pakistani rupee' = 'PKR',
  'Polish złoty' = 'PLN',
  'Paraguayan guaraní' = 'PYG',
  'Qatari riyal' = 'QAR',
  'Romanian new leu' = 'RON',
  'Serbian dinar' = 'RSD',
  'Russian rouble' = 'RUB',
  'Rwandan franc' = 'RWF',
  'Saudi riyal' = 'SAR',
  'Solomon Islands dollar' = 'SBD',
  'Seychelles rupee' = 'SCR',
  'Sudanese pound' = 'SDG',
  'Swedish krona/kronor' = 'SEK',
  'Singapore dollar' = 'SGD',
  'Saint Helena pound' = 'SHP',
  'Sierra Leonean leone' = 'SLL',
  'Somali shilling' = 'SOS',
  'Surinamese dollar' = 'SRD',
  'South Sudanese pound' = 'SSP',
  'São Tomé and Príncipe dobra' = 'STD',
  'Syrian pound' = 'SYP',
  'Swazi lilangeni' = 'SZL',
  'Thai baht' = 'THB',
  'Tajikistani somoni' = 'TJS',
  'Turkmenistani manat' = 'TMT',
  'Tunisian dinar' = 'TND',
  'Tongan paʻanga' = 'TOP',
  'Turkish lira' = 'TRY',
  'Trinidad and Tobago dollar' = 'TTD',
  'New Taiwan dollar' = 'TWD',
  'Tanzanian shilling' = 'TZS',
  'Ukrainian hryvnia' = 'UAH',
  'Ugandan shilling' = 'UGX',
  'United States dollar' = 'USD',
  'United States dollar (next day) (funds code)' = 'USN',
  'United States dollar (same day) (funds code) (one source[who?] claims it is no longer used, but it is still on the ISO 4217-MA list)' = 'USS',
  'Uruguay Peso en Unidades Indexadas (URUIURUI) (funds code)' = 'UYI',
  'Uruguayan peso' = 'UYU',
  'Uzbekistan som' = 'UZS',
  'Venezuelan bolívar fuerte' = 'VEF',
  'Vietnamese dong' = 'VND',
  'Vanuatu vatu' = 'VUV',
  'Samoan tala' = 'WST',
  'CFA franc BEAC' = 'XAF',
  'Silver (one troy ounce)' = 'XAG',
  'Gold (one troy ounce)' = 'XAU',
  'European Composite Unit (EURCO) (bond market unit)' = 'XBA',
  'European Monetary Unit (E.M.U.-6) (bond market unit)' = 'XBB',
  'European Unit of Account 9 (E.U.A.-9) (bond market unit)' = 'XBC',
  'European Unit of Account 17 (E.U.A.-17) (bond market unit)' = 'XBD',
  'East Caribbean dollar' = 'XCD',
  'Special drawing rights' = 'XDR',
  'UIC franc (special settlement currency)' = 'XFU',
  'CFA franc BCEAO' = 'XOF',
  'Palladium (one troy ounce)' = 'XPD',
  'CFP franc' = 'XPF',
  'Platinum (one troy ounce)' = 'XPT',
  'Code reserved for testing purposes' = 'XTS',
  'No currency' = 'XXX',
  'Yemeni rial' = 'YER',
  'South African rand' = 'ZAR',
  'Zambian kwacha' = 'ZMW',
}

export enum MoldConcentration {
  NO_MOLD = 'NO_MOLD',
  LOW_MOLD = 'LOW_MOLD',
  MEDIUM_MOLD = 'MEDIUM_MOLD',
  HIGH_MOLD = 'HIGH_MOLD',
}

export enum ContactMoldOverviewStrength {
  LOW = 'niedrig',
  MEDIUM = 'mittel',
  HIGH = 'hoch',
}

export enum ContactMoldStrength {
  PLUS = '+',
  PLUS_PLUS = '++',
  PLUS_PLUS_PLUS = '+++',
  PLUS_PLUS_PLUS_PLUS = '++++',
}

export enum ContactMoldKind {
  ANFLUG = 'Anflug',
  BEFALL = 'Befall',
  NONE = 'none',
}
